const styles = {
  wrapper:
    'border border-gray-2 rounded-2 min-h-32 md:min-h-40 px-5 py-3 md:px-8 md:py-4 hover:bg-black-light',
  department: 'text-lead text-pink',
  title: 'text-h5 font-normal line-clamp-2',
  location: 'text-body1 text-gray-4 mt-1',
};

export default styles;
